<template>
  <div>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <v-dialog v-model="dialogFlag" width="400">
      <v-card tile class="white">
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <span class="modals-title-size">
            <b>Repeat Task</b>
          </span>

          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="py-2"
          >Repeat frequency:
          <v-select
            outlined
            dense
            color="#2a206a"
            class="text-capitalize my-1"
            :items="['daily', 'weekly', 'monthly']"
            v-model="repeatFrequency"
            label="Doesn't repeat"
            solo
            hide-details
            flat
          >
            <template v-slot:item="{ item }">
              <div class="text-capitalize">
                {{ item ? item : "Doesn't repeat" }}
              </div>
            </template>
          </v-select>
          <div class="d-flex w-100 align-center">
            <v-spacer></v-spacer>
            <v-btn
              v-if="repeatFrequency"
              x-small
              text
              class="float-right"
              @click="repeatFrequency = null"
              >reset</v-btn
            >
          </div>
        </v-card-text>

        <!-- save button -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="reset-btn text-capitalize"
            @click="dialogFlag = false"
            color="darken-1"
            tile
            text
            >Cancel
          </v-btn>
          <v-btn
            class="text-capitalize btn-success white--text"
            color="darken-1"
            text
            id="assign-btn"
            tile
            @click="repeatTask()"
            >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import moment from "moment";
export default {
  name: "RepeatTaskDialog",
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  data() {
    return {
      dialogFlag: false,
      repeatFrequency: null,
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getLoggedInUser",
      "getAllMembers",
      "getProjects",
      "getActiveTask",
      "getView",
      "getTask",
      "getKanbanTask",
    ]),
  },

  props: ["openRepeatTaskDialog", "task"],
  mixins: [snackbarMixin],
  watch: {
    openRepeatTaskDialog(value) {
      if (value) {
        this.dialogFlag = true;
        if (this.task && this.task.recurring_type)
          this.repeatFrequency = this.task.recurring_type;
        else this.repeatFrequency = null;
      } else this.dialogFlag = false;
    },
    dialogFlag(value) {
      !value ? this.$emit("update:openRepeatTaskDialog", false) : () => {};
    },
  },
  methods: {
    closeDialog() {
      this.selectedMembers = [];
      this.$emit("update:openRepeatTaskDialog", false);
    },
    repeatTask() {
      let oldData = {
        is_recurring: this.task.recurring_type ? true : false,
        recurring_type: this.task.recurring_type,
      };
      let data = {
        company_id: this.getSelectedCompany.id,
        task_id: this.task.task_id,
        is_recurring: this.repeatFrequency ? true : false,
        recurring_type: this.repeatFrequency,
      };
      this.$store.dispatch("updateTask", data)
      .then((response)=>{
         this.openSnackbar(false, "Task repeat sucessfully");
      })
      .catch(() => {
        oldData.task = this.getTask(this.task.task_id);

        this.$store.commit("setUpdatedTask", oldData);

        // ERROR Snackbar
        this.openSnackbar(true, "Task repeat unsucessful");
      });

      // Temporary update
      (data.task = this.getTask(this.task.task_id)),
        this.$store.commit("setUpdatedTask", data),
        this.dialogFlag = false;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.v-autocomplete__content.v-menu__content .v-select-list {
  border-radius: 0 0 4px 4px;
  max-height: 136px;
  overflow: scroll;
}
</style>
<style>
.v-application .primary--text {
  color: #1cc283 !important;
  caret-color: #e9fcf5 !important;
}
</style>
